import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faBalanceScale, faSeedling, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { usePortfolio } from './../Context/PortfolioContext';
import './PortfolioMetricsCard.css';
const preprocessAssetData = (selectedAssets) => {
  // Example: Identify the common date range (simplified)
  const commonStart = Math.max(...selectedAssets.map(asset => new Date(Object.keys(asset.monthly_prices)[0]).getTime()));
  const commonEnd = Math.min(...selectedAssets.map(asset => new Date(Object.keys(asset.monthly_prices).pop()).getTime()));

  // Adjust prices to only include the common range or forward fill missing data
  selectedAssets.forEach(asset => {
      Object.keys(asset.monthly_prices).forEach(date => {
          const dateTs = new Date(date).getTime();
          if (dateTs < commonStart || dateTs > commonEnd) {
              delete asset.monthly_prices[date]; // Remove prices outside the common range
          }
          // Add forward fill logic here if needed
      });
      // Repeat for yearly_prices if necessary
  });

  return selectedAssets;
};
function calculatePortfolioVolatility(selectedAssets, weights) {
  let squaredWeightedVolatilities = 0;
  for (let i = 0; i < selectedAssets.length; i++) {
    const assetVolatility = selectedAssets[i].volatility;
    const weight = weights[i];
    squaredWeightedVolatilities += Math.pow(weight * assetVolatility, 2);
  }
  const portfolioVolatility = Math.sqrt(squaredWeightedVolatilities);
  return portfolioVolatility;
}
function calculateWeightedESGScore(selectedAssets, weights) {
  let weightedESGScore = 0;
  for (let i = 0; i < selectedAssets.length; i++) {
    const assetESGScore = (selectedAssets[i].ESGworkforce + selectedAssets[i].ESGstrategy) / 2; // Average of ESGworkforce and ESGstrategy
    const weight = weights[i];
    weightedESGScore += assetESGScore * weight;
  }
  return weightedESGScore;
}


function calculateWeightedReturn(selectedAssets, weights) {

  let weightedReturn = 0;

  for (let i = 0; i < selectedAssets.length; i++) {
    const assetReturn = selectedAssets[i].return; // Assuming 'return' is a property containing the asset's return
    const weight = weights[i];
    weightedReturn += assetReturn * weight;
  }

  return weightedReturn;
}


const PortfolioMetricsCard = ({ selectedAssets, optimizationResults }) => {
  // Assuming 'weights' is an array of portfolio weights corresponding to each 'selectedAssets' in order
  const weights = optimizationResults.optimizedWeights || [];
  const money = optimizationResults.wealth || 0;
  // Calculate Weighted Yearly Return (%)
  console.log('Data for PortoflioMetricsCard', selectedAssets);
  console.log(optimizationResults); // Log the entire object
  console.log('The weight for the PortfolioMetricsCard is ', weights);
  console.log('the value of the wealth is', money);


  console.log('The wealth is');
  const weightedYearlyReturn = calculateWeightedReturn(selectedAssets, weights)*100 || 0;

  const portfolioVolatility = calculatePortfolioVolatility(selectedAssets, weights)*100 || 0;
  // Calculate Weighted ESG Score
  const weightedESGScore = calculateWeightedESGScore(selectedAssets, weights) || 0;
  const profitTHB = calculateWeightedReturn(selectedAssets, weights)*money || 0;
  return (
    <>
    <h1>Optimization Result</h1>
        <div className="portfolio-metrics-card">
            <div className="metric">
                <FontAwesomeIcon icon={faChartLine} /> <span>Yearly Return: {weightedYearlyReturn.toFixed(2)}%</span>
            </div>
            <div className="metric">
                <FontAwesomeIcon icon={faBalanceScale} /> <span>Sharp Ratio: {(weightedYearlyReturn/portfolioVolatility).toFixed(2)}</span>
            </div>
            <div className="metric">
                <FontAwesomeIcon icon={faSeedling} /> <span>ESG Score: {weightedESGScore.toFixed(2)}</span>
            </div>
            <div className="metric">
                <FontAwesomeIcon icon={faDollarSign} /> <span>Profit: ฿{profitTHB.toFixed(2)} per year</span>
            </div>
        </div>
        </>
  )
};

export default PortfolioMetricsCard;
